import { loadingBar } from '../global/constants';

;(function($) {

	$(document).ready(function() {

		// ---------- Handle consent checkbox ----------

		$('#checkbox-consent').change(
			function() {
				if($(this).is(':checked')) {
					$('.form-group-submit button').prop("disabled", false);
				} else {
					$('.form-group-submit button').prop("disabled", true);
				}
			}
		);


		// ---------- Handle Form ----------

		function handleForm(form, params) {

			const formContent = form.find('.form-content');
			const formDone = form.find('.form-done');
			const formSuccess = formDone.find('.success');
			const formError = formDone.find('.error');
			const formHoneyPot = formContent.find('.honeyinput').get(0);
			// const formButton = form.find('button[type=submit]');

			// form.find('[name=date]').datepicker({
			// 	container: form.find('.date-picker'),
			// 	inline: true,
			// 	autoPick: false,
			// 	language: 'fr-FR',
			// 	format: 'dd-mm-yyyy',
			// 	startDate: Date.now(),
			// 	filter: (params === booking_cottage_params) ? (date, view) => {
			// 		const currentMonth = date.getMonth();
			// 		const currentDay = date.getDate();
			// 		const closedMonths = !(currentMonth > 2 && currentMonth < 11);
			// 		const openedDays = (currentMonth === 3 && currentDay < 2) || (currentMonth === 10 && currentDay > 15);
			//
			// 		if(view === 'day' && closedMonths || openedDays) {
			// 			return false;
			// 		}
			//
			// 		return true;
			//
			// 	} : null,
			// });

			form.parsley().on('form:submit', function() {

				if(formHoneyPot.value) return false;

				loadingBar.classList.add('active');

				const formData = new FormData(form[0]);
				formData.append('action', params.action);
				formData.append('nonce', params.nonce);

				// formButton.attr('disabled', true);



				$.ajax({
					url: params.url,
					type: 'POST',
					dataType: 'json',
					data: formData,
					processData: false,
					contentType: false,
				}).always(function(response) {

					loadingBar.classList.remove('active');
					formContent.addClass('d-none');
					formDone.removeClass('d-none');
					// formButton.attr('disabled', false);

					if(response.success === true) {
						formSuccess.removeClass('d-none');

						// if(typeof gtag === 'function') {
						// 	gtag('event', 'reservation', {
						// 		'event_category': 'formulaire',
						// 		'event_label': 'reservation_gites',
						// 	});
						// }
					}
					else {
						formError.removeClass('d-none');
						console.error(response);
					}
				});

				return false;
			});
		}

		// ---------- Gites Form ----------

		if(typeof booking_cottage_params !== 'undefined') {

			$('form#booking-form').each(function() {
				handleForm($(this), booking_cottage_params);
			});
		}
	});

}(jQuery));
